import { cn } from '@agnes/ui';
import { BaseComponentProps } from '@/components/BaseComponentProps';
import { cva } from 'class-variance-authority';
import { ANALISE_STATUS_NOMES, AnaliseStatus } from '@/constants/analise/AnaliseStatus';
import { BadgeEmAnalise } from '@/components/analise/BadgeEmAnalise';

export interface BadgeStatusAnaliseProps extends BaseComponentProps {
  status: AnaliseStatus;
  size?: 'sm' | 'md' | 'lg';
}

const badgeCVA = cva(
  'flex items-center justify-start gap-1 justify-self-start font-semibold whitespace-nowrap',
  {
    variants: {
      status: {
        EM_ANALISE: '', // Utiliza componente BadgeEmAnalise
        PENDENTE_DE_ESCLARECIMENTO: 'text-agnes-warning bg-agnes-warning/10',
        ANALISADO: 'text-agnes-success bg-agnes-success/10',
      },
      size: {
        sm: 'px-1 py-0.5 text-xs rounded-md',
        md: 'px-2 py-0.5 text-sm rounded-md',
        lg: 'px-3 py-1 text-md rounded-lg',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

export function BadgeStatusAnalise({
  className,
  status,
  size,
  dataQa,
  ...props
}: BadgeStatusAnaliseProps) {
  if (status === 'EM_ANALISE') {
    return <BadgeEmAnalise dataQa={dataQa} size={size} {...props} />;
  }

  return (
    <span className={cn(badgeCVA({ status, size }), className, 'whitespace-nowrap')} {...props}>
      {ANALISE_STATUS_NOMES[status]}
    </span>
  );
}
